import styled from 'styled-components';
import {
  colors,
  BREAKPOINTS,
  FONT_FAMILIES,
} from 'common/styles/style-constants';
import {
  P,
  Div,
  Span,
  MarketingButton,
} from 'common/styles/oc-styled-components';

export const LoggedInBox = styled(Div)`
  background-color: #fcfbfc;
  border: 1px solid ${colors.silver};
  border-radius: 5px;
`;

export const LogoutLink = styled.button`
  display: flex;
  align-items: center;
  appearance: none;
  cursor: pointer;
  background: none;
  border: none;
  font-family: ${FONT_FAMILIES.circular};
  color: ${colors.darkBlue};
  font-size: 16px;
  font-weight: 600;
  height: 100%;
  padding: 0 1px 0 3px;
  margin: 5px 0 0 0;

  span {
    margin-right: 7px;
  }

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export const SSOLogo = styled.img`
  height: 24px;
  margin-right: ${props => (props.isMobile ? '0' : '17px')};
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    height: ${props => (props.height ? props.height : '18px')};
  }
`;

export const SSOLoginButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  padding: 18px;
  border-radius: 3px;
  background: ${colors.white};
  border: 1px solid ${colors.silver};
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05);
  font-weight: 600;
  font-size: 16px;
  color: ${colors.gray9};
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${colors.sage5};
    border: 1px solid ${colors.sage5};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const SSOLoginButtonMobile = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 8px 15px;
  margin-top: 15px;

  height: 40px;
  width: calc(30% - 10px);
  min-width: 100px;
  border: none;
  cursor: pointer;
  border-radius: 10px;
  background-color: ${props =>
    (props.background ? props.background : colors.black)};
`;

export const HorizontalBreak = styled.div`
  position: relative;
  margin: ${props => props.margin};
  color: ${colors.gray7};
  text-align: center;
  font-weight: 400;

  &:before,
  &:after {
    content: '';
    display: block;
    width: 40%;
    height: 1px;
    background: ${colors.gray6};
    position: absolute;
    top: 50%;
  }

  &:before {
    left: 0;
  }
  &:after {
    right: 0;
  }
`;

export const PatientLoginButton = styled(MarketingButton)`
  && {
    padding: 10px 25px !important;
  }
`;

export const ForgotPasswordLink = styled(P)`
  && {
    font-weight: bold;
    text-align: center;
    margin: -5px 0 5px;
    transition: all 0.2s ease-in-out;
    color: ${colors.black} !important;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const SignInUpLink = styled(Span)`
  && {
    color: ${colors.coral};
    text-decoration: underline;
    transition: all 0.2s ease-in-out;
    &:hover {
      text-decoration: none;
    }
  }
`;
